/**
 * Short dates the office reads on a warning or a finding: "24 Sep".
 *
 * One copy for every check that names the day a quote or a message arrived
 * (materials, payment terms, the AI Team page), so the three cannot drift.
 */

const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

/**
 * "24 Sep", from the date part alone so no timezone moves it. Null when the
 * text does not start with a `YYYY-MM-DD` date.
 */
export function shortDayMonth(at: string): string | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(at);
  if (!match) return null;
  return `${Number(match[3])} ${MONTHS[Number(match[2]) - 1]}`;
}
